"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCareVideoType = exports.ProductCareMediaType = exports.ProductDetailReviewType = exports.ProductDetailTabTypes = void 0;
var ProductDetailTabTypes;
(function (ProductDetailTabTypes) {
    ProductDetailTabTypes["SPECIFICATIONS"] = "specifications";
    ProductDetailTabTypes["REVIEWS"] = "reviews";
    ProductDetailTabTypes["DESCRIPTION"] = "description";
    ProductDetailTabTypes["FEATURE_CATEGORIES"] = "featureCategories";
    ProductDetailTabTypes["PRODUCT_CARE"] = "productCare";
    ProductDetailTabTypes["OUR_PLANET"] = "ourPlanet";
})(ProductDetailTabTypes || (exports.ProductDetailTabTypes = ProductDetailTabTypes = {}));
var ProductDetailReviewType;
(function (ProductDetailReviewType) {
    ProductDetailReviewType["USER"] = "user";
    ProductDetailReviewType["EXPERT"] = "expert";
})(ProductDetailReviewType || (exports.ProductDetailReviewType = ProductDetailReviewType = {}));
var ProductCareMediaType;
(function (ProductCareMediaType) {
    ProductCareMediaType["IMAGE"] = "image";
    ProductCareMediaType["VIDEO"] = "video";
})(ProductCareMediaType || (exports.ProductCareMediaType = ProductCareMediaType = {}));
var ProductCareVideoType;
(function (ProductCareVideoType) {
    ProductCareVideoType["EMBEDDED_LINK"] = "embeddedLink";
    ProductCareVideoType["DAM"] = "damAsset";
})(ProductCareVideoType || (exports.ProductCareVideoType = ProductCareVideoType = {}));
//# sourceMappingURL=ProductTypes.js.map